import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card.tsx';
import { useRunOnce } from '@/hooks/use-run-once';
import { useSessionSave } from '@/hooks/use-session-save';
import { setExitMilestone } from '@/hooks/use-session-store/use-session-store';
import { endTrackingSession } from '@/lib/analytics';
import { MILESTONES } from '@/lib/wizard/milestones';

export function InsuranceWaitlistThankYou() {
  const { saveSession } = useSessionSave();

  useRunOnce(() => {
    setExitMilestone(MILESTONES.WAITLISTED);
    saveSession();
    endTrackingSession();
  });

  return (
    <section>
      <Card>
        <CardHeader>
          <CardTitle className="text-center">Thanks for your interest!</CardTitle>
        </CardHeader>

        <CardContent>
          <p className="text-center">We’ll keep you posted and share updates as we expand.</p>
        </CardContent>
      </Card>
    </section>
  );
}
